import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminKitchenPrintLogsPage,
  AdminKitchenPrintLogsQuery,
} from 'shared-models/browser';

export type {
  AdminKitchenPrintLogsPage,
  AdminKitchenPrintLogsQuery,
  AdminKitchenPrintLogView,
} from 'shared-models/browser';

class AdminKitchenPrintsService {
  async list(query: AdminKitchenPrintLogsQuery = {}): Promise<AdminKitchenPrintLogsPage> {
    try {
      const response = await authenticatedInstance.get<AdminKitchenPrintLogsPage>('/payments/admin/kitchen-prints', {
        params: query,
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const adminKitchenPrintsService = new AdminKitchenPrintsService();
